<template>

<b-row class="w-100 d-flex justify-content-center align-items-center" style="padding-top: 10px; padding-left: 20px; height:80%; margin: 0;">
        <loading :active="loading"
                :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        <apexchart v-if="series && !thereIsNoData" id="chart" style="flex:1; padding: 10px 10px 10px 0;"
        width="100%" height="90%" ref="apexchart" 
        :options="chartOptions" 
            :series="series" />
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {generateLabelDateArray, getProjectPeriodByHistory} from '@/components/chatter/util/graphUtils';

export default {
    name: 'ProjectProductivityGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        this.historyData = this.dashboardData.history;
        this.projectUserData = this.dashboardData.projectUser;

        if(this.projectUserData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.startDate = this.dashboardData.projectInfo.startDate;
            this.endDate = this.dashboardData.projectInfo.endDate;

            // 시작, 종료 날짜 둘중 하나라도 비어있으면 히스토리에서 시작, 종료 가져옴
            if(this.startDate == '' || this.endDate == '') {
                const [historyStart, historyEnd ] = getProjectPeriodByHistory(this.historyData);

                this.startDate = historyStart;
                this.endDate = historyEnd;
            }
        }
        this.reloadGraph();
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                console.log("modify filter reload");
                
                this.series = [];
                this.chartOptions.xaxis.categories = [];
                this.reloadGraph();
            }
        },
    },
    data() {
        return {
            startDate :'',
            endDate : '',
            historyData: '',
            projectUserData: '',
            thereIsNoData: false,
            loading: false,
            columnNames: [],
            series: [],
            interval: 7,
            dateRange : [],
            chartOptions: {
                chart: {
                    height:'80%',
                    type: "area",
                    stacked: true,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                colors: ['#553AC1', '#1BD4D4'],
                markers: {
                    size: this.isFlexible ? 3 : 0,
                    strokeWidth: 1,
                },
                dataLabels: {
                    enabled: this.isFlexible, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors: ['#fff'], // 데이터 라벨의 색상을 지정합니다.
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -13, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#2E2E38',
                        padding: 5,
                        borderRadius: 7,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 1,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                stroke: {
                    width: [4, 4, 4, 4],
                    curve: 'straight',
                },
                xaxis: {
                    categories: [],
                    show:this.isFlexible,
                    labels: {
                        show:this.isFlexible
                    }
                },
                yaxis: {
                    labels: {
                        show:this.isFlexible
                    }
                },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid : {
                    show:false
                }
            },
            tableData: [],
        }
    },
    methods: {
        getLabelArray() {

            // 프로젝트 정보의 startDate, endDate가 없을 때
            // 데이터의 label 정보로 초기화
            let from = this.startDate;
            let to = this.endDate;

            //여기서 eow를 사용하지 않아서 null 처리
            //graphUtils 에서 null로 받으면 프로젝트 첫 시작을로 처리하는 로직 있음
            let eow = null;
            let interval = 7;
            
            // Flexible Graph일 때 filters 값이 우선순위
            if(this.isFlexible) {
                if(this.filters.from != '') {
                    from = this.filters.from;
                }

                if(this.filters.to != '') {
                    to = this.filters.to;
                }

                if(this.filters.interval != '') {
                    interval = this.filters.interval;
                }

                if(this.filters.eow != '') {
                    eow = this.filters.eow;
                }
            }

            let labelDateArray = generateLabelDateArray(from, to, null, interval, eow);            

            return labelDateArray;
        },

        countData(labelArray, dataArray) {

            const arraySize = labelArray.length;

            // 프로젝트 User 테이블에서 role의 집합 구하기
            let roleSet = new Set();
            dataArray.forEach(user => {
                roleSet.add(user.role);
            });

            let roleArray = [...roleSet];
            
            if(roleArray.length > 4) {
                this.chartOptions.legend.show = false;
            }

            // role별로 카운트하기 위한 Object 생성
            let countObj = {}
            roleArray.forEach(role => {
                countObj[role] = new Array(arraySize).fill(0);
            });

            let index = 0;
            let interval = 1;
            interval = Number(interval);
            for(let labelDate of labelArray) {

                let startDate = new Date(labelDate);
                let endDate = new Date(startDate);

                endDate.setDate(endDate.getDate() + interval);

                this.projectUserData.forEach(user=> {
                    // roleIn, roleOut이 없으면 프로젝트의 시작, 종료 or 히스토리 시작, 종료 날짜로 초기화
                    let roleIn = user.roleIn == '' ? this.startDate : user.roleIn;
                    let roleOut = user.roleOut == '' ? this.endDate : user.roleOut;
                
                    roleIn = new Date(roleIn);
                    roleOut = new Date(roleOut);
                    
                    if(startDate >= roleIn && endDate <= roleOut) {
                        countObj[user.role][index]++;
                    }
                })
                index++;
            }

            let series = [];

            roleArray.forEach(role => {
                series.push({
                    name: role,
                    data: countObj[role],
                })
            });

            return series;
        },

        visualizeGraph() {

            let dataArray = this.projectUserData;

            // Project User는 따로 필터링을 만들어야 함
            // if(this.isFlexible) {
            //     let L1 = this.filters.L1;
            //     let L2 = this.filters.L2;
            //     let L3 = this.filters.L3;
            //     let JOB = this.filters.JOB;
            //     let PRIORITY = this.filters.PRIORITY;
            //     let TYPE = this.filters.TYPE;

            //     // None 값을 ""로 변경
            //     L1 = L1.map(value => value === "None" ? "" : value);
            //     L2 = L2.map(value => value === "None" ? "" : value);
            //     L3 = L3.map(value => value === "None" ? "" : value);
            //     JOB = JOB.map(value => value === "None" ? "" : value);
            //     PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
            //     TYPE = TYPE.map(value => value === "None" ? "" : value);

            //     dataArray = dataArray.filter(item => {

            //         return (
            //             L1.includes(item.l1) &&
            //             L2.includes(item.l2) &&
            //             L3.includes(item.l3) &&
            //             JOB.includes(item.job) &&
            //             PRIORITY.includes(item.priority) &&
            //             TYPE.includes(item.type)
            //         );
            //     });
            // }

            let labelDateArray = this.getLabelArray();

            let countObj = this.countData(labelDateArray, dataArray);
            
            this.series = countObj;
            this.label = labelDateArray;

            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.xaxis.categories = this.label;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions(this.chartOptions);
            }
        },
        setTable() {
            this.tableData = this.data.table;

        }
    },
}
</script>
